import { ActionTree } from 'vuex';
import { State } from './cloud.store';
import {
  SET_CURRENT_SERVICE,
  SET_CURRENT_VENDOR,
  GET_GKE_CLUSTERS,
  GET_GKE_NAMESPACES,
  SET_GKE_CLUSTERS,
  SET_CURRENT_GKE_CLUSTER,
  SET_CURRENT_GKE_TAB,
  SET_CURRENT_GKE_TAB_MUTATION,
  SET_GKE_NAMESPACES,
  SET_CURRENT_GKE_NAMESPACE,
} from './cloud.constant';
import { Context } from '@/utils/types/global';
import graphQl from '@/services/graphQl';
import { AxiosResponse } from 'axios';

export const actions: ActionTree<State, any> = {
  [SET_CURRENT_SERVICE]({ commit }, params) {
    if (params != undefined && params != '') commit('setCurrentSvc', params);
    else commit('setCurrentSvc', '');
  },
  [SET_CURRENT_VENDOR]({ commit }, params) {
    if (params != undefined && params != '') commit('setCurrentVendor', params);
    else commit('setCurrentVendor', '');
  },
  async [GET_GKE_CLUSTERS](
    context: Context,
    params: { duration: any; serviceReq: any },
  ) {
    const subType = context.rootState.cloudState.services.cloudSvc;
    if (!params.serviceReq) {
      params.serviceReq = {
        capability: 'C',
        subType: subType,
      };
    }
    return graphQl
      .query('queryGKEClusters')
      .params(params)
      .then((res: AxiosResponse) => {
        let resData = res.data.data.services;
        let customData: Object[] = [];
        resData.forEach(function (arrayItem: any) {
          let newLabel = arrayItem.label.split('|$|')[0];
          let obj = { key: arrayItem.key, label: newLabel };
          customData.push(obj);
        });
        context.commit(SET_GKE_CLUSTERS, customData);
        if (customData.length > 0) {
          context.commit(SET_CURRENT_GKE_CLUSTER, customData[0]);
        } else {
          context.commit(SET_CURRENT_GKE_CLUSTER, '');
        }
      })
      .catch((err) => console.log('error', err));
  },
  async [GET_GKE_NAMESPACES](
    context: Context,
    params: {
      duration: any;
      serviceReq: any;
      serviceId: string;
      teamId: string;
      propertyName: string;
      properties: any;
    },
  ) {
    params.serviceId =
      context.rootState.cloudState.services.currentGKECluster.key;
    params.propertyName = 'metaProperty3'; // property used for storing namespace info
    let currentTab = context.rootState.cloudState.services.currentGkeTab;
    currentTab = currentTab === 'NODES' ? 'POD' : currentTab.replace('S', '');
    params.properties = [
      {
        key: 'instanceType',
        value: currentTab,
      },
    ];
    return graphQl
      .query('listDistinctPropertyValues')
      .params(params)
      .then((res: AxiosResponse) => {
        let resData = res.data?.data?.listDistinctPropertyValues;
        let customData: Object[] = [];
        resData?.forEach((arrayItem: any) =>
          customData.push({ key: arrayItem, label: arrayItem }),
        );
        context.commit(SET_GKE_NAMESPACES, customData);
        context.commit(
          SET_CURRENT_GKE_NAMESPACE,
          customData.length > 0 ? customData[0] : '',
        );
      })
      .catch((err) => console.log('error', err));
  },
  [SET_CURRENT_GKE_TAB]({ commit }, params) {
    commit(SET_CURRENT_GKE_TAB_MUTATION, params);
  },
};

export default actions;
